import { render, staticRenderFns } from "./UpdatePayPassword.vue?vue&type=template&id=e362970c&scoped=true&"
import script from "./UpdatePayPassword.vue?vue&type=script&lang=js&"
export * from "./UpdatePayPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e362970c",
  null
  
)

export default component.exports